import ResourceHelper from 'helpers/ResourceHelper';

const PermissionItem = ({ data, defaultValue }) => {
  return (
    <li className="list-group-item d-flex align-items-center justify-content-between">
      <div>
        <div>
          <b>{data.name}</b>
        </div>
        <div>{data.description}</div>
      </div>

      <div className="form-check form-switch">
        <input className="form-check-input" type="checkbox" defaultChecked={defaultValue} id={data.id} />
      </div>
    </li>
  );
};

const PermissionList = ({ permissions = {} }) => {
  const resources = ResourceHelper.all();
  const items = resources.map(permission => {
    const default_value = typeof permissions[permission.id] === 'undefined' ? permission.default_value : permissions[permission.id];
    return <PermissionItem key={permission.id} data={permission} defaultValue={default_value} />;
  });

  return <ul className="list-group mt-3 col-md-12">{items}</ul>;
};

export default PermissionList;
